import { GetReportRun } from "api/rpc/2024-04/facilityAdmin/report/report";
import { useReportPresentation } from "./ReportPresentationContext";
import { CancelToken } from "axios";

export function useReportRun() {
    const { hiddenColumns, groupBy } = useReportPresentation();
  
    return async (
      params: any,
      useGlobalLoader: boolean,
      token?: CancelToken,
    ) => {
      return GetReportRun(
        {
          ...params,
          presentation: params?.type === "csv" || params?.type === "print" ? {hidden_columns: hiddenColumns, group_by: groupBy} : undefined,
        },
        useGlobalLoader,
        token,
      );
    };
  }